module.exports = __webpack_public_path__ + "static/hero-image-mobile-1abc25defd96340ec1f68a832cfff3c9.jpg";